<div class="billing-reports">
  <app-loader *ngIf="isLoading"></app-loader>
<!--   <div class="billing-reports-header">
    BILLING REPORTS
  </div> -->
  <div class="date-content">
    <div class="date-label">
      <span class="date-text">Select Date</span>
    </div>
    <!-- *ngIf="inputControlStartDate && inputControlEndDate" -->
    <!-- [customStyle]="'billing-reports'"  -->
    <div class="form-group">
      <app-mis-datepicker class="date-position" [singleDateEnabled]="false" [config]="dateMaxConfig" (selectedDate)="selectedDate($event)"></app-mis-datepicker>
      <div *ngIf="displayInvalidDateMessage"><span class="invalid-dates">{{displayInvalidDateMessage}}</span></div>
    </div>
  </div>
  <div class="select-content">
    <!-- <div class="select-label">
      <span class="select-text">Select Option</span>
    </div> -->
    <ng-container *ngIf="filterSectionConfig && formDetails">
    <ng-container *ngFor="let field of filterSectionConfig?.elementConfigList">
      <ng-container *ngIf="checkVisibility(field.config, formDetails)">
        <!-- <div class="form-control filter-item mr-20" > -->
          <!-- <div class="form-input"> -->
          <div class="form-input-group">
            <div class="select-label">
              <span class="select-text">{{field.config.displayName}}</span>
            </div>
          <app-field-generator *ngIf="field.elementKey !== 'Select Vendor'"
            [config]="field.config" [inputControl]="getFormControl(field.elementKey)" [customStyle]="'billing-reports'">
          </app-field-generator>
          <app-multiselect
            *ngIf="field.elementKey === 'Select Vendor'"
            [label]="'Select Options'"
            [formControl]="formDetails.get(field.elementKey)"
            [options]="vendorMap"
            valueKey="guid"
            labelKey="vendorName"
            [optionMap]="vendorMap"
            [width]="'150px'"
          >
          </app-multiselect>
          </div>
          <!-- </div> -->
        <!-- </div> -->
      </ng-container>
    </ng-container>
  </ng-container>
  </div>
  <div class="download-content">
    <div class="download-content-column">
      <div class="download-header">
        <span class="download-header-text">Download Reports</span>
      </div>
      <div class="download-buttons-content">
        <button mis-button type="none" size="lg" class="button" (click)="handleDownloadTripReport()">
          <span mis-input-icon class="btn-icon"><img src="/assets/images/download-report.svg" alt="" /></span>
          Trip cost report
        </button>
      </div>
     </div>
    <div class="download-content-column">
      <div class="download-header">
        <span class="download-header-text">Upload</span>
      </div>
      <div class="download-buttons-content">
        <app-file-upload-input
        labelText='Upload toll, parking etc'
        (uploadReportCallback)="handleUploadReport($event)"
        [fileName]="fileName"
        [styleType]="'height_lg'"
        >
      </app-file-upload-input>
        <button mis-button type="none" size="lg" class="button" (click)="handleDownloadTemplate()">
          <span mis-input-icon class="btn-icon"><img src="/assets/images/download-report.svg" alt="" /></span>
          Download template
        </button>
      </div>
    </div>
    <!-- <div class="download-content-column"> -->
      <div class="download-content-column" *ngIf="lastUploadedFileName">
      <div class="download-header">
        <span class="download-header-text">Last Uploaded</span>
      </div> 
      <div class="download-buttons-content">
        <button mis-button type="none" size="lg" *ngIf="lastUploadedFileName" class="button" (click)="handleDownloadTemplate()">
          <span mis-input-icon class="btn-icon"><img src="/assets/images/upload-file.svg" alt="" /></span>
          {{lastUploadedFileName}}
        </button>
      </div>
    </div>

    </div>
  <!-- </div> -->
<!--   <div class="billing-reports-container">
    <div class="billing-reports-filters-wrapper">
      <div class="date-filter-container">
        <div class="date-filters">
          <div class="start-date-wrapper header-item mr-20">
            <label class="form-label mr-10">Start Date</label>
            <app-date-picker *ngIf="inputControlStartDate" [config]="dateMaxConfig" [formControl]="inputControlStartDate" (changeCallback)="onStartDateChange($event)"></app-date-picker>
          </div>
          <div class="end-date-wrapper header-item mr-20">
            <label class="form-label mr-10">End Date</label>
          <app-date-picker *ngIf="inputControlEndDate" [config]="dateMaxConfig" [formControl]="inputControlEndDate" (changeCallback)="onEndDateChange($event)"></app-date-picker>
          </div>
        </div>
        <div class="invalid-date" *ngIf="displayInvalidDateError">{{displayInvalidDateMessage}}</div>
      </div>
      <div class="filter-option-wrapper" *ngIf="filterSectionConfig && formDetails">
        <ng-container *ngFor="let field of filterSectionConfig.elementConfigList">
          <ng-container *ngIf="checkVisibility(field.config, formDetails)">
            <div class="form-control filter-item mr-20" >
              <label class="form-label">
                {{field.config.displayName}}
              </label>
              <div class="form-input">
              <app-field-generator *ngIf="field.elementKey !== 'Select Vendor'"
                [config]="field.config" [inputControl]="getFormControl(field.elementKey)" >
              </app-field-generator>
              <app-multiselect
                *ngIf="field.elementKey === 'Select Vendor'"
                [formControl]="formDetails.get(field.elementKey)"
                [options]="vendors"
                valueKey="guid"
                labelKey="vendorName"
                [optionMap]="vendorMap"
              >
              </app-multiselect>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="download-upload-container">
      <div class="download-billing-reports-wrapper">
        <div class="header">Download Reports</div>
        <div class="trip-cost-report" (click)="handleDownloadTripReport()">
          <img src="assets/download.svg"/>
          Trip Cost  Report
        </div> -->
        <!-- <div class="billing-report" (click)="handleDownloadBillingReport()">
          <img src="assets/download.svg"/>
          Raw Billing Data
        </div> -->
    <!--   </div>
      <div class="upload-reports-wrapper">
        <div class="header">Upload</div>
        <div class="upload-report" [ngClass]="{'disabled': displayInvalidDateError}">
          <app-file-upload-input
            labelText='Upload toll, parking etc'
            (uploadReportCallback)="handleUploadReport($event)"
            [fileName]="fileName">
          </app-file-upload-input>
        </div>
        <div class="download-template" (click)="handleDownloadTemplate()">
          <img src="assets/download.svg"/>
          Download template
        </div>
        <div class="last-uploaded-container" *ngIf="lastUploadedFileName">
          <div class="last-updated-wrapper">
            <div class="header">Last Uploaded</div>
            <div class="file-name" (click)="handleDownloadFile()">{{lastUploadedFileName}}</div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <app-file-upload
    [showFileUploadModal] = "showFileUploadModal"
    [fileToUpload]="fileToUpload"
    (submitUploadReportCallback)="submitUploadReport()"
    (handleDismissUploadFileModal)="handleDismissUploadFileModal()"
    [uploadFileError]="uploadFileError">
  </app-file-upload>
  <app-toast *ngIf="showUploadSuccess" message="Upload Successful" (dismissCallback)="toggleToast()">
  </app-toast>
  <app-dialog *ngIf="showErrorDialog" type="alert" [buttonText]="['Okay']" (approveCallback)="dismissError()">
    {{errorMessage}}
  </app-dialog>

  <app-popover *ngIf="showFileErrors" size="billing-upload-error" (closeCallback)="dismissFileError()">
    <div popover-header class="error-header">
      <mat-icon class="error-icon-align" svgIcon="error"></mat-icon>
      <span>
        Errors
      </span>
    </div>
    <div popover-content class="error-table-wrapper autoscroll">
      <table class="error-table">
        <thead class="error-table-head">
          <th class="column-header group-no">Sl No.</th>
          <th class="column-header column-name row-no">Row Number</th>
          <th class="column-header column-name">Field Name</th>
          <th class="column-header">Error Description</th>
        </thead>
        <tbody class="error-table-body">
          <tr class="error-table-row" *ngFor="let error of this.failedRows; let index=index">
            <td class="ellipsis group-no">{{index+1}}</td>
            <td class="ellipsis row-no">{{error.rowNo}}</td>
            <td class="ellipsis column-name">{{error.columnName}}</td>
            <td >{{error.errorMessage}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </app-popover>

  <app-toast *ngIf="showSuccessToast" [message]="successMessage" (dismissCallback)="toggleToastBillRepost()">
  </app-toast>
</div>
